<div *ngFor="let presenter of presentersList; trackBy: trackByPresenterId" [class]="styles.presenterVideoWrap">
	<div vbDraggable [dragData]="presenterVideo.getDragData" [dragOptions]="dragOptions" [dragEnabled]="canEditLayout">
		<presenter-video #presenterVideo [webcast]="webcast" [isProducer]="isProducer(presenter.id)" [backstageVolume]="backstageVolume" [onstageVolume]="onstageVolume" [name]="presenter.name" [presenter]="presenter" [producerOptions]="producerOptions" [canEditLayout]="canEditLayout">
		</presenter-video>
	</div>
</div>
